export default __webpack_public_path__ + "static/media/insert_emoticon.cb87d886.svg";